import React, { useRef, useState } from 'react';
import RequestAdminLocalPW from 'widgets/RequestAdminLocalPW';
import ticketListActions from 'features/ticketList/services/actions';
import { useAppDispatch } from 'store/hooks';
import { IStaffItemData } from 'services/shop/types/staff';
import { Button } from 'antd';
import { FeaturePermission } from 'constants/Permission';
import ticketListApis from 'features/ticketList/services/apis';
import toast from 'utils/toast';
import { getMessageError } from 'services/response';
import { IUnrevokeTicketBody } from 'features/ticketList/services/types/api';
import UnrevokedNoteModal, { UnrevokedNoteRef } from './UnrevokedNoteModal';

const UnrevokedButton = (props: React.ButtonHTMLAttributes<HTMLButtonElement> & { selectedRowKeys: string[]; onSuccess: () => void }) => {
  const [visiblePW, setVisiblePW] = useState(false);
  const dispatch = useAppDispatch();
  const unrevokedNoteModal = useRef<UnrevokedNoteRef>(null);

  const showRequestAdminLocalPW = () => {
    setVisiblePW(true);
  };

  const onUnrevokedTicketSuccess = () => {
    dispatch(ticketListActions.afterDeleteClosedTicket());
    props.onSuccess();
  };

  const onVerifyAdminSuccess = (pin?: string, staffDataVerified?: IStaffItemData) => {
    setVisiblePW(false);
    const billIds = props.selectedRowKeys;
    const data = {
      billIds: billIds,
      staffId: staffDataVerified?.id || '',
    };
    unrevokedNoteModal.current?.open(data, onUnrevokedTicketSuccess);
  };

  return (
    <div>
      <Button {...props} type='primary' onClick={showRequestAdminLocalPW}>
        Unrevoked
      </Button>
      {visiblePW && (
        <RequestAdminLocalPW
          onlyAdmin
          visible
          v2={true}
          onCorrect={onVerifyAdminSuccess}
          onClose={() => setVisiblePW(false)}
          featureCode={FeaturePermission.DELETE_TICKET}
        />
      )}
      <UnrevokedNoteModal ref={unrevokedNoteModal} />
    </div>
  );
};

export default UnrevokedButton;
